<template>
  <create-account-layout
    :current-step="3"
    title="Your Profile"
  >
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <div>
        <div v-if="claimedCarrier && !isEmailRequiredForLogin">
          <p class="my-6 text-left text-dark-gray">
            Let's get some basic information.
          </p>
          <div>
            <form-field
              label="Full Name"
              :value="full_name"
              placeholder="Enter your full name"
              :on-input="handleFieldUpdate"
              :error="full_name_error"
              :alert-message="full_name_alert"
              name="full_name"
            />
            <form-field
              label="Company Email"
              :value="email_address"
              placeholder="Enter your company email"
              :on-input="handleFieldUpdate"
              :on-blur="checkEmailAddress"
              :error="email_address_error"
              name="email_address"
            />
          </div>
        </div>
        <div v-else>
          <p class="my-6 text-left text-dark-gray">
            For you to be able to join this carrier, we need an authorized
            representative of the carrier to grant you access.
          </p>
          <p class="my-6 text-left text-dark-gray">
            A request will be sent to the contact methods publicly registered
            with the FMCSA and to any users already belonging to this account.
          </p>
        </div>

        <button-main
          class="mt-3"
          :disabled="buttonDisabled"
          type="submit"
          :loading-spinner="isLoading"
          value="Continue"
        />
      </div>
    </form>
  </create-account-layout>
</template>

<script>
import CreateAccountLayout from '@/components/layouts/CreateAccountLayout.vue';
import ButtonMain from '@/components/Button.vue';
import FormField from '@/components/FormField.vue';
import { formatFirstLastName } from '@/common/validators';
import { toastResponse } from '@/common/handleServerResponse';

//Mixin
import fullnameAndEmailField from '@/mixins/fullnameAndEmailField';

export default {
  name: 'RequestAccess',
  components: {
    CreateAccountLayout,
    ButtonMain,
    FormField,
  },
  mixins: [fullnameAndEmailField],
  data() {
    return {
      isLoading: false,
      claimedCarrier: true,
    };
  },
  computed: {
    buttonDisabled() {
      if (this.isEmailRequiredForLogin) {
        return false;
      } else if (
        this.claimedCarrier &&
        !(this.full_name && this.email_address)
      ) {
        return true;
      } else {
        return false;
      }
    },
    isEmailRequiredForLogin() {
      return this.$store.state.carriers?.isEmailRequiredForLogin;
    },
  },
  mounted() {
    const findInput = document.querySelector('#full_name');
    if (findInput) {
      setTimeout(() => {
        findInput.focus();
      }, 0);
    }
    this.checkClaimedCarrier();
  },
  methods: {
    async checkClaimedCarrier() {
      const contactsData = this.$store.state.carriers.maskedContacts;

      if (contactsData && !contactsData.length) this.claimedCarrier = false;
    },
    async handleSubmit() {
      this.isLoading = true;
      if (this.claimedCarrier && !this.isEmailRequiredForLogin) {
        const { first_name, last_name } = formatFirstLastName(this.full_name);

        const userRes = await this.$store.dispatch('users/patchSignUpDetails', {
          first_name,
          last_name,
          email: this.email_address,
        });

        if ([200, 201].includes(userRes.status)) {
          // Success updating user information
          // look for onboarding connection id
          this.$router.push({
            name: 'RequestAccessFMSCA',
          });
        } else {
          // handle error for updating user details
          toastResponse(this, userRes, null);
        }
      } else {
        this.$router.push({
          name: 'RequestAccessFMSCA',
        });
      }
      this.isLoading = false;
    },
  },
};
</script>

<style>
.radio-class {
  @apply border-white;
}
.radio-class > label {
  @apply rounded-md bg-white;
}

.radio-class > label > .checkmark {
  @apply bg-off-white;
}
</style>
